<template>
  <div>
    <b-modal
      id="delete-benefit-modal"
      title="Confirm Delete"
      hide-footer
    >
      <div class="text-center">
        <p>Are you sure you want to delete this benefit?</p>
        <b-button
          :disabled="deletingBenefit"
          class="mr-2"
          variant="primary"
          @click="$bvModal.hide('delete-benefit-modal')"
        >
          Cancel
        </b-button>
        <b-button
          :disabled="deletingBenefit"
          variant="danger"
          @click="deleteBenefit"
        >
          <b-spinner
            v-if="deletingBenefit"
            small
            class="mr-1"
          />
          Yes, Delete
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="view-benefit-modal"
      title="Benefit Details"
      hide-footer
    >
      <div v-if="selectedBenefit">
        <p><strong>Name En:</strong> {{ selectedBenefit.name.en }}</p>
        <p><strong>Name Ar:</strong> {{ selectedBenefit.name.ar }}</p>
        <p><strong>Description En:</strong> {{ selectedBenefit.description.en }}</p>
        <p><strong>Description Ar:</strong> {{ selectedBenefit.description.ar }}</p>
        <p><strong>Status:</strong> {{ selectedBenefit.is_active ? 'Active' : 'Inactive' }}</p>
        <p><strong>Type:</strong> {{ selectedBenefit.benefit_type }}</p>
        <p><strong>Discount %:</strong> {{ selectedBenefit.config.discount_percentage }}</p>
        <p><strong>Rides Limit:</strong> {{ selectedBenefit.config.rides_limit }}</p>
        <p><strong>Created At:</strong> {{ formatDate(selectedBenefit.created_at) }}</p>
      </div>
    </b-modal>

    <benefit-modal
      ref="createBenefitModal"
      :benefit="selectedBenefit"
      @done="fetchBenefits"
    />
    <b-card>
      <b-button
        variant="primary"
        class="mb-1"
        @click="addBenefitHandler"
      >
        Add Benefit
      </b-button>
      <b-overlay
        :show="loading"
        opacity=".75"
        blur="0"
        rounded="sm"
        spinner-variant="primary"
      >
        <b-table
          :fields="tableColumns"
          :items="list"
          :sort-by.sync="queryParams.sortBy"
          :sort-desc.sync="queryParams.sortDesc"
          show-empty
          empty-text="No benefits created yet."
          class="text-center mb-2"
        >
          <template #cell(actions)="data">
            <b-button
              variant="flat-primary"
              class="btn-icon"
              @click="viewBenefit(data.item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>

            <b-button
              variant="flat-warning"
              class="btn-icon"
              @click="editBenefit(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              variant="flat-danger"
              class="btn-icon"
              @click="confirmDelete(data.item)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </template>
        </b-table>

        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @input="fetchBenefits"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BCard, BOverlay, BButton, BSpinner,
} from 'bootstrap-vue'
import useBenefitsList from '../hooks/use-benefits-list'
import benefitModal from '../components/benefit-form-modal.vue'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BasePagination,
    BSpinner,
    BTable,
    BButton,
    BCard,
    benefitModal,
    BOverlay,
  },
  setup(_, ctx) {
    return {
      ...useBenefitsList(ctx),
    }
  },
}
</script>
